var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1735 3.48688H4.96091C3.2336 3.48688 1.83333 4.8871 1.83333 6.61435V17.0394C1.83333 18.7666 3.2336 20.1668 4.96091 20.1668H15.3861C17.1135 20.1668 18.5137 18.7666 18.5137 17.0394L18.5137 11.8269M7.04595 14.9543L10.839 14.19C11.0404 14.1495 11.2252 14.0503 11.3704 13.905L19.8615 5.40956C20.2686 5.00225 20.2683 4.34201 19.8609 3.93504L18.0622 2.13842C17.6549 1.73161 16.995 1.73189 16.588 2.13904L8.09609 10.6354C7.95117 10.7804 7.85221 10.9649 7.8116 11.1658L7.04595 14.9543Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dd04c582b5c9615085245d1b219a7a02.svg";
export { ForwardRef as ReactComponent };